const STORAGE_KEY = "kf0wwr-hotkeys"
const root = document.documentElement
const dialog = document.getElementById("keys")
const toggle = document.getElementById("hotkeys-toggle")

const enabled = () => {
  try { return localStorage.getItem(STORAGE_KEY) !== "off" } catch { return true }
}

const render = () => {
  root.classList.toggle("hotkeys-off", !enabled())
  if (toggle) toggle.textContent = `[ hotkeys: ${enabled() ? "ON" : "OFF"} ]`
}

const booting = () => root.classList.contains("booting") && !document.getElementById("boot")?.classList.contains("done")

const ignore = event =>
  event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey ||
  event.target.closest?.("input, textarea, select, [contenteditable]") ||
  dialog?.open || booting()

const moveSelection = step => {
  const links = [...document.querySelectorAll(".msg-list .row-link")]
  if (!links.length) return false
  const current = links.indexOf(document.activeElement)
  const next = current === -1
    ? (step > 0 ? 0 : links.length - 1)
    : Math.min(Math.max(current + step, 0), links.length - 1)
  links[next].focus()
  return true
}

document.addEventListener("keydown", event => {
  if (!enabled() || ignore(event)) return
  const key = event.key.toLowerCase()
  const target = [...document.querySelectorAll("[data-hotkey]")].find(element => element.dataset.hotkey === key)
  if (target) {
    event.preventDefault()
    target.click()
  } else if ((key === "j" || key === "k") && moveSelection(key === "j" ? 1 : -1)) {
    event.preventDefault()
  }
})

if (dialog) {
  document.querySelectorAll("[data-open-keys]").forEach(button => button.addEventListener("click", () => dialog.showModal()))
  dialog.querySelector("[data-close-keys]")?.addEventListener("click", () => dialog.close())
  dialog.addEventListener("click", event => { if (event.target === dialog) dialog.close() })
  toggle?.addEventListener("click", () => {
    try { localStorage.setItem(STORAGE_KEY, enabled() ? "off" : "on") } catch {}
    render()
  })
}

render()
